import type { PrivacyRequest, PrivacyRequestKind } from 'shared';

export const PRIVACY_REQUEST_LABEL: Record<PrivacyRequestKind, string> = {
  copy: 'Cópia dos dados',
  erasure: 'Eliminar conta',
};

/** What staff do to answer each kind. */
export const PRIVACY_REQUEST_HOW: Record<PrivacyRequestKind, string> = {
  copy: 'Abre a pessoa, usa "Exportar dados" e envia-lhe o ficheiro.',
  erasure: 'Confirma com a pessoa, abre-a e usa "Eliminar". O pedido fica tratado sozinho.',
};

/** How close an open request is to its deadline. */
export type DeadlineTone = 'late' | 'soon' | 'ok';

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function deadlineTone(request: Pick<PrivacyRequest, 'dueAt'>, now: Date): DeadlineTone {
  const left = new Date(request.dueAt).getTime() - now.getTime();
  if (left < 0) return 'late';
  if (left < WEEK_MS) return 'soon';
  return 'ok';
}

/** Where the person behind a request is managed in the backoffice. */
export function subjectPath(request: Pick<PrivacyRequest, 'participantId' | 'guardianId'>): string {
  if (request.participantId !== null) return `/users/${request.participantId}`;
  return `/encarregados?id=${request.guardianId}`;
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Lisbon',
  });
}
